<template>
    <div class="main-body">
        <div class="header-subnav-container">
            <PageHeader current-app="cross-platform" />
            <SubNav />
        </div>
        <div class="webtool-container">
            <router-view />
            <div v-if="visibleBanner" class="alert alert-dark text-center mb-0 banner browserWarning" role="alert">
                NOTE: The tool is optimized for Chrome browser
                <button type="button" class="btn btn-primary btn-sm ms-3 mb-lg-0 browserBannerBtn" @click="hideBrowserBanner()">
                    OK
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    import SubNav from "./SubNav/SubNav"
import PageHeader from "./PageHeader/PageHeader"
import { fetchFormFieldData } from "@/api/api.js"
import appsConfig from "./PageHeader/appsConfig.js"

export default {
    name: "Layout",
    components: {
        SubNav,
        PageHeader,
    },
    data() {
        return {
            visibleBanner: false,
        }
    },
    async created() {
        const queryString = window.location.search
        const urlParams = new URLSearchParams(queryString)
        let token = urlParams.get("token")
        let user = urlParams.get("user")

        if (token === null) {
            token = localStorage.getItem("accessToken", token)
            user = localStorage.getItem("user", user)
        }

        localStorage.setItem("accessToken", token)
        localStorage.setItem("user", user)

        this.$store.commit("setLoggedIn", true)
        this.$store.commit("setUser", user)
        this.$store.commit("setAccessToken", token)

        await fetchFormFieldData("User")
            .then(user => {
                this.setApplicationAccess(user.applications)
                this.$store.commit("setInternalAndMMSOnly", user.internalAndMMSOnly)
                localStorage.setItem("user", user.email)
                this.$store.commit("setUser", user.email)
                for (let i = 0; i < user.applications.length; i++) {
                    if (user.applications[i].applicationName == "total-analys") {
                        this.$store.commit("setFullAccess", true)
                    }
                }
            })
            .catch(error => {
                if (error.response?.status != 401) this.toastMessage("Problem occurred while fetching user.", false)
                console.error(error)
            })
        //Fetch Message from api
        await fetchFormFieldData("Message")
            .then(messages => {
                if (messages.statusCode) {
                    this.toastMessage(messages.errorMessage, false)
                } else {
                    this.$store.commit("setObsMessage", messages.obsMessage)
                    this.$store.commit("setDataLogMessage", messages.dataLogMessage)
                }
            })
            .catch(error => {
                if (error.response?.status != 401) this.toastMessage("Problem occurred while fetching messages.", false)
                console.error(error)
            })
        let success = await this.$store.dispatch("updateSSASMessage")
        if (!success) {
                            this.toastMessage("Problem fetching default dates from server. The service will not work correctly.", false)
            return
        }
    },
    mounted() {
        this.initializeBanner()
    },
    methods: {
        setApplicationAccess(applications) {
            let broadcastAccess = applications.filter(application => application.applicationName.includes("tv-analys")).length > 0
            appsConfig.find(appConfig => appConfig.id == "broadcast").userAccess = broadcastAccess
            let onlineVideoAccess = applications.filter(application => application.applicationName.includes("online")).length > 0
            appsConfig.find(appConfig => appConfig.id == "online-video").userAccess = onlineVideoAccess
            let videoInHomeAccess = applications.filter(application => application.applicationName == "video-in-home").length > 0
            appsConfig.find(appConfig => appConfig.id == "video-in-home").userAccess = videoInHomeAccess
        },
        initializeBanner() {
            if (localStorage.getItem("browserBanner") == null && !this.$browserDetect.isChrome) this.visibleBanner = true
        },
        hideBrowserBanner() {
            localStorage.setItem("browserBanner", true)
            this.visibleBanner = false
        },
    },
}
</script>

<style scoped>
.main-body {
    display: flex;
    flex-direction: column;
    height: 100vh;
}
.header-subnav-container {
    flex: 0 0 auto;
}
.webtool-container {
    display: flex;
    flex-direction: column;
    max-height: 100%;
    flex: 1;
}
.banner {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 999;
    border-radius: 0;
    background: #424851;
}

.browserWarning {
    color: red;
}

.browserBannerBtn {
    float: right;
    background: #97d058;
    border: none;
}
</style>
